import React from 'react'

import { Badge, FormOnChange, Radio, RadioGroup } from '@procsea/design-system'

import { OrderType } from 'src/types'

export type OrderTypeSelectorValue = OrderType.TODAY | OrderType.FUTURE | OrderType.PAST

export interface OrderTypeSelectorProps {
  futureOrdersCount?: number
  label?: string
  name?: string
  onChange: FormOnChange<string | Id>
  todayOrdersCount?: number
  value?: OrderTypeSelectorValue
}

const OrderTypeSelector = ({
  futureOrdersCount = 0,
  label,
  name = 'order-type',
  onChange,
  todayOrdersCount = 0,
  value,
}: OrderTypeSelectorProps) => (
  <RadioGroup
    collapsed
    data-e2e="order-type-selector"
    format="toggled"
    label={label}
    name={name}
    onChange={onChange}
    value={value}
  >
    <Radio
      content={
        <>
          {gettext('Today')}&nbsp;
          <Badge content={todayOrdersCount} data-e2e="today-orders-count" variant="danger" />
        </>
      }
      data-e2e="order-type-today"
      value={OrderType.TODAY}
    />
    <Radio
      content={
        <>
          {gettext('To come')}&nbsp;
          <Badge content={futureOrdersCount} data-e2e="future-orders-count" variant="neutral" />
        </>
      }
      data-e2e="order-type-future"
      value={OrderType.FUTURE}
    />
    <Radio content={gettext('Past')} data-e2e="order-type-past" value={OrderType.PAST} />
  </RadioGroup>
)

export default OrderTypeSelector
